import {
    getSpikeZone,
    getSpikeInfo,
    getHomeSpike,
    isActivity, // 活动是否已结束
    getEffectList, // 优惠券列表
    getCouponNum, // 下单可用优惠券数量
    getEffectNum, // 优惠券数量
    getMyCouponList, // 领券中心
    getMyCoupon, // 优惠券详情
    getDraw, // 领取优惠券
    getActivityList, // 商品详情获取优惠券列表
    getTopicActivity, // 专题活动（未授权）
    getFloorsData, // 专题活动楼层（未授权）
    getTopicActivity2, // 专题活动(授权)
    getFloorsData2, // 专题活动楼层（授权）
    getActivityMore, // 专题活动楼层更多
    getActivity, // 确认下单最优活动
    inventoryList, // 我的清单列表
    clearProductNum, // 清空我的清单列表
    getGroupsPurchaseHomePage,
    getGroupsPurchaseList,
    getGroupsPurchaseSomeList,
    addProduct // 专题活动添加商品到清单
} from '../api/activity'
import {
    GET_BANK,
    GET_MY_BANK,
    GET_SEARCH_BANK_LIST,
    GET_ASSETS_USER_INFO,
    GET_BANKCARD_WITHDRAW_LIST,
    GET_BANKCARD_CASHIERDESK,
    GET_OPEN_ACCOUNT_INFO
} from './const.js'
import {
    getSendSms, // 发送验证码
    getMyMember, // 我的推荐列表
    getRegister, // 用户注册
    updateAvatar, // 修改头像
    updateMobile, // 修改手机号
    updateName, // 修改姓名
    updatePassWord, // 修改密码
    isApprove, // 是否认证
    createCompany, // 创建企业
    editCompany, // 修改企业
    outCompany, // 退出企业
    companyList, // 获取企业列表
    switchCompany, // 切换企业
    addCompany, // 添加商家邀请码
    staffList, // 员工列表
    delStaff, // 移除员工
    floorsInfo, // 获取楼层信息
    getColumn, // 首页专栏列表
    getToken, // 获取最新token
    bannerInfo, // 获取banner信息
    getFloorProduct, // 获取更多楼层商品
    getUserInfo, // 获取用户信息
    getcartList, // 获取购物车列表
    cartNum, // 获取购物车数量
    delCart, // 批量删除购物车商品
    getCartNum, // 获取商品购物车的数量
    addShop, // 加入购物车
    buryPoint, // 埋点
    activityInfo, // 活动埋点
    getArea, // 获取省市区地址
    getRebate, // 获取最大返利
    getStatus, // 当前商品的状态
    getIsPay, // 是否开启账期
    submitOrder, // 确认订单提交
    getCollectNum, // 查看收藏夹数量
    getOrderNum, // 查看订单数量g
    getPayment, // 获取账期额度
    getSuper, // 首页浮层
    getHome2, // 根据平台公司获取首页
    getMyServer, // 我的服务数据
    getbrandList, // 品牌列表
    getbrandSpell, // 获取品牌按字母
    findIndexCategoryList, // 类目列表
    getBank, // 根据卡号获取银行卡信息
    getSearchBankList, // 根据卡号获取银行卡信息
    getMyBank, // 获取我的银行卡列表
    getAssetsUserInfo, // 获取钱包用户信息
    getBankcardWithdrawList, // 提现银行卡列表
    getCashierdesk, // 支付收银台
    getMemberList, // 获取战区信息列表
    getOpenAccountInfo // 企业银行开户信息
} from '../api/api'
import { // 地址信息
    getDefaultAddress, // 默认地址
    getAddressList, // 地址列表
    depotAddress, // 仓库地址列表
    editAddress, // 编辑地址
    addressDetail, // 地址详情
    delAddress, // 删除地址
    saveAddress // 保存地址
} from '../api/address'
import {
    findProductList, // 获取商品列表
    getGoodsDetail, // 获取spu商品详情
    getSkuGoodsDetail, // 获取sku商品详情
    getSpecs, // 获取商品组
    getMyCollect, // 获取收藏夹列表
    addAllCollect, // 批量加入收藏夹
    addFavorite, // 加入收藏
    cancelFavorite, // 取消收藏
    isCollect, // 是否收藏
    rebateShow, // 返利说明
    getProductData, // 确认下单商品获取
    getGoodAttr, // 商品附件
    getIsTerm, // 是否支付账期支付
    getTermInfo, // 账期信息
    paymentTerm, // 账期支付
    groudDetail, // 拼团商品详情
    getGroupsPurchaseDetail, // 拼团详情
    getIsGroup, // 会员是否可以参加拼团
    getOrderGroupDetail, // 订单详情拼团信息
    getGroupIsProcessing, // 拼团是否进行中
    isPriceData // 判断商品是否显示价格是否购买
} from '../api/product'
import {
    findOrderDetails, // 订单详情
    orderTk, // 订单退款
    revokeOrder // 撤销退款
} from '../api/order'
import {
    findAcconutDetails, // 公司转账账户信息
    getPaymentInform
} from '../api/payment'
let user = JSON.parse(localStorage.getItem('userInfo'))
export default {
    // 团购首页
    async getGroupsPurchaseHomePage ({ commit }, payload) {
        const { data } = await getGroupsPurchaseHomePage(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 团购列表
    async getGroupsPurchaseList ({ commit }, payload) {
        const { data } = await getGroupsPurchaseList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 团购具体某个活动列表
    async getGroupsPurchaseSomeList ({ commit }, payload) {
        const { data } = await getGroupsPurchaseSomeList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取用户信息
    async getUserInfoData ({ dispatch, commit }, payload) {
        const { data } = await getUserInfo({})
        if (data) {
            localStorage.setItem('userInfo', JSON.stringify(data))
            data.companyCode && await dispatch('isApprove', { companyCode: data.companyCode })
            return Promise.resolve(data)
        }
    },
    // 拼团商品详情
    async getGroupDetail ({ commit }, payload) {
        const { data } = await groudDetail(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 拼团详情
    async getGroupsPurchaseDetail ({ commit }, payload) {
        const { data } = await getGroupsPurchaseDetail(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 会员是否可以参团购买
    async getIsGroup ({ commit }, payload) {
        const { data } = await getIsGroup(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 订单详情拼团信息
    async getOrderGroupDetail ({ commit }, payload) {
        const { data } = await getOrderGroupDetail(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 拼团活动基本详情
    async getGroupIsProcessing ({ commit }, payload) {
        const { data } = await getGroupIsProcessing(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 判断价格是否显示
    async isPriceData ({ commit }, payload) {
        const { data } = await isPriceData(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 我的推荐列表
    async getMyMember ({ commit }, payload) {
        const { data } = await getMyMember(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 修改头像
    async updateAvatar ({ commit }, payload) {
        const { data } = await updateAvatar(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 更换手机号
    async updateMobile ({ commit }, payload) {
        const { data } = await updateMobile(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 修改姓名
    async updateName ({ commit }, payload) {
        const { data } = await updateName(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 修改密码
    async updatePassWord ({ commit }, payload) {
        const { data } = await updatePassWord(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 发送验证码
    async setSendSms ({ commit }, payload) {
        const { data } = await getSendSms(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 用户注册
    async setRegister ({ commit }, payload) {
        const { data } = await getRegister(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 是否认证
    async isApprove ({ commit }, payload) {
        const { data } = await isApprove(payload)
        if (data) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let userData = {
                ...userInfo,
                ...data
            }
            localStorage.setItem('userInfo', JSON.stringify(userData))
            return Promise.resolve(data)
        }
    },
    // 创建企业
    async createCompany ({ commit }, payload) {
        const { data } = await createCompany(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 切换企业
    async setSwitch ({ commit }, payload) {
        const { data } = await switchCompany(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 修改企业
    async editCompany ({ commit }, payload) {
        const { data } = await editCompany(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 退出企业
    async outCompany ({ commit }, payload) {
        const { data } = await outCompany(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 企业列表
    async getCompanyList ({ commit }, payload) {
        const { data } = await companyList({})
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取战区信息列表
    async getMemberList ({ commit }, payload) {
        const { data } = await getMemberList({})
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 添加商家邀请码
    async addCompany ({ commit }, payload) {
        const { data } = await addCompany(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 员工列表delStaff
    async staffListData ({ commit }, payload) {
        const { data } = await staffList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 移除员工
    async delStaffData ({ commit }, payload) {
        const { data } = await delStaff(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 埋点
    async setBuried ({ commit }, payload) {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        payload.type = payload.type || 5
        payload.dfx_type = payload.dfx_type || 1
        payload.login_name = userInfo ? userInfo.phone : ''
        payload.user_name = userInfo ? userInfo.name : ''
        payload.user_id = userInfo ? userInfo.id : ''
        payload.member_code = userInfo ? userInfo.companyCode : ''
        payload.member_name = userInfo ? userInfo.companyName : ''
        payload.merchant_code = userInfo ? userInfo.belongMerchantCode : ''
        payload.merchant_name = userInfo ? userInfo.belongMerchantName : ''
        payload.source = payload.source || 1
        await buryPoint({
            ...payload
        })
    },
    // 活动埋点
    async setActivity ({ commit }, payload) {
        await activityInfo(payload)
    },
    // 获取购物车列表delCart
    async getcartListData ({ commit }, payload) {
        const { data } = await getcartList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 批量删除购物车的商品
    async delCartData ({ commit }, payload) {
        const { data } = await delCart(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取购物车数量
    async getCartNums ({ commit }, payload) {
        const { data } = await cartNum({
            merchantCode: payload.merchantCode || user.belongMerchantCode,
            memberCode: payload.memberCode || user.companyCode
        })
        commit('GET_CARTNUMS', data)
    },
    // 获取购物车数量
    async getProductCartNum ({ commit }, payload) {
        const { data } = await getCartNum(payload)
        return Promise.resolve(data)
    },
    // 加入购物车
    async addShopData ({ commit }, payload) {
        const { data } = await addShop(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取楼层信息
    async getFloorsInfo ({ commit }, payload) {
        const { data } = await floorsInfo(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 首页专栏
    async getColumn ({ commit }, payload) {
        const { data } = await getColumn(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取更多楼层商品信息
    async getFloorProductData ({ commit }, payload) {
        const { data } = await getFloorProduct(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取商品列表
    async getProductList ({ commit }, payload) {
        const { data } = await findProductList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取spu商品详情
    async getGoodsDetailData ({ commit }, payload) {
        const { data } = await getGoodsDetail(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取sku商品详情
    async getSkuGoodsDetail ({ commit }, payload) {
        const { data } = await getSkuGoodsDetail(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取商品状态
    async getStatusData ({ commit }, payload) {
        const { data } = await getStatus(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取商品组
    async getSpecs ({ commit }, payload) {
        const { data } = await getSpecs(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 确认下单商品获取
    async getProductData ({ commit }, payload) {
        const { data } = await getProductData(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 确认下单提交
    async getSubmitOrder ({ commit }, payload) {
        const { data } = await submitOrder(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 返利说明
    async rebateShowData ({ commit }, payload) {
        const { data } = await rebateShow({
            spuId: payload.spuId
        })
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 返利说明
    async getGoodAttrData ({ commit }, payload) {
        const { data } = await getGoodAttr(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 返利说明
    async getRebateData ({ commit }, payload) {
        const { data } = await getRebate(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 加入收藏
    async addFavoriteData ({ commit }, payload) {
        const { data } = await addFavorite(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 取消收藏
    async cancelFavoriteData ({ commit }, payload) {
        const { data } = await cancelFavorite(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 取消收藏
    async isCollectData ({ commit }, payload) {
        const { data } = await isCollect(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 收藏夹列表
    async getMyCollect ({ commit }, payload) {
        const { data } = await getMyCollect(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 批量加入收藏夹
    async addAllCollect ({ commit }, payload) {
        const { data } = await addAllCollect(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取banner信息
    async getBannerInfo ({ commit }, payload) {
        const { data } = await bannerInfo(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 特价专区
    async getSpikeZone ({ commit }, payload) {
        const { data } = await getSpikeZone(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 特价活动列表
    async getSpikeInfo ({ commit }, payload) {
        const { data } = await getSpikeInfo(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 特价活动首页列表
    async getHomeSpike ({ commit }, payload) {
        const { data } = await getHomeSpike(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取活动是否结束
    async getIsActivity ({ commit }, payload) {
        const { data } = await isActivity(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动(未授权)
    async getTopicActivity ({ commit }, payload) {
        const { data } = await getTopicActivity(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动楼层列表(未授权)
    async getFloorsData ({ commit }, payload) {
        const { data } = await getFloorsData(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动(授权)
    async getTopicActivity2 ({ commit }, payload) {
        const { data } = await getTopicActivity2(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动楼层列表(授权)
    async getFloorsData2 ({ commit }, payload) {
        const { data } = await getFloorsData2(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动楼层更多
    async getActivityMore ({ commit }, payload) {
        const { data } = await getActivityMore(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动添加商品到清单
    async addProduct ({ commit }, payload) {
        const { data } = await addProduct(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动我的商品清单列表
    async inventoryList ({ commit }, payload) {
        const { data } = await inventoryList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 专题活动清空我的商品清单列表
    async clearProductNum ({ commit }, payload) {
        const { data } = await clearProductNum(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取省市区地址
    async getArea ({ commit }, payload) {
        const { data } = await getArea({})
        if (data) {
            localStorage.setItem('areaList', JSON.stringify(data))
            commit('GET_AREALIST', data)
        }
    },
    // 获取最新token
    async getToken ({ commit }, payload) {
        const { data } = await getToken({})
        if (data) {
            localStorage.setItem('token', data.access_token)
            localStorage.setItem('refreshToken', data.refresh_token)
        }
    },
    // 是否开启账期
    async getIsPay ({ commit }, payload) {
        const { data } = await getIsPay(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 查看订单的数量
    async getOrderNumData ({ commit }, payload) {
        const { data } = await getOrderNum(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取账期额度
    async getPaymentData ({ commit }, payload) {
        const { data } = await getPayment(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 查看收藏夹数量
    async getCollectNumData ({ commit }, payload) {
        const { data } = await getCollectNum(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 仓库地址列表
    async getDepotAddress ({ commit }, payload) {
        const { data } = await depotAddress(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 优惠券数量
    async getEffectNumData ({ commit }, payload) {
        const { data } = await getEffectNum(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 商品优惠券列表
    async getActivityList ({ commit }, payload) {
        const { data } = await getActivityList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 领券中心
    async getMyCouponListData ({ commit }, payload) {
        const { data } = await getMyCouponList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 我的优惠券列表
    async getEffectList ({ commit }, payload) {
        const { data } = await getEffectList(payload)
        return Promise.resolve(data)
    },
    // 优惠券详情
    async getMyCouponData ({ commit }, payload) {
        const { data } = await getMyCoupon(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 领取优惠券
    async getDrawData ({ commit }, payload) {
        const { data } = await getDraw(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 确认下单最优活动
    async getActivityData ({ commit }, payload) {
        const { data } = await getActivity(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 下单可用优惠券数量
    async getCouponNumData ({ commit }, payload) {
        const { data } = await getCouponNum(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 浮层
    async getSuperData ({ commit }, payload) {
        const { data } = await getSuper(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 根据平台公司获取首页数据
    async getMerHomeData ({ commit }, payload) {
        const { data } = await getHome2(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 类目列表
    async findCategoryListData ({ commit }, payload) {
        const { data } = await findIndexCategoryList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 品牌列表
    async getbrandListData ({ commit }, payload) {
        const { data } = await getbrandList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 品牌字母列表
    async getbrandSpell ({ commit }, payload) {
        const { data } = await getbrandSpell(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 查询我的服务信息
    async getMyServerData ({ commit }, payload) {
        const { data } = await getMyServer(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取地址列表
    async getAddressListData ({ commit }, payload) {
        const { data } = await getAddressList(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 获取默认地址
    async getDefaultAddress ({ commit }, payload) {
        const { data } = await getDefaultAddress(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 保存地址
    async saveAddressData ({ commit }, payload) {
        const { data } = await saveAddress(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 编辑地址
    async editAddressData ({ commit }, payload) {
        const { data } = await editAddress(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 地址详情
    async addressDetailData ({ commit }, payload) {
        const { data } = await addressDetail(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 删除地址
    async delAddressData ({ commit }, payload) {
        const { data } = await delAddress(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    async getBankAct ({ commit }, params) {
        const { data } = await getBank(params)
        commit(GET_BANK, data)
    },
    async getMyBankAct ({ commit }, params) {
        const { data } = await getMyBank(params)
        commit(GET_MY_BANK, data)
    },
    async getBankSearchListAct ({ commit }, params) {
        const { data } = await getSearchBankList(params)
        commit(GET_SEARCH_BANK_LIST, data)
    },
    // 订单详情
    async findOrderDetails ({ commit }, payload) {
        const { data } = await findOrderDetails(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 订单退款
    async orderTk ({ commit }, payload) {
        const { data } = await orderTk(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 撤销退款
    async revokeOrder ({ commit }, payload) {
        const { data } = await revokeOrder(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 是否支持账期支付
    async getIsTerm ({ commit }, payload) {
        const { data } = await getIsTerm(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 账期信息
    async getTermInfo ({ commit }, payload) {
        const { data } = await getTermInfo(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 账期支付
    async paymentTerm ({ commit }, payload) {
        const { data } = await paymentTerm(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 公司转账账户信息
    async findAcconutDetailsData ({ commit }, payload) {
        const { data } = await findAcconutDetails(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    // 线下转账通知信息
    async getPaymentInformData ({ commit }, payload) {
        const { data } = await getPaymentInform(payload)
        if (data) {
            return Promise.resolve(data)
        }
    },
    async getAssetsUserInfoAct ({ commit }, params) {
        const { data } = await getAssetsUserInfo(params)
        commit(GET_ASSETS_USER_INFO, data)
    },
    async getBankcardWithdrawListAct ({ commit }, params) {
        const { data } = await getBankcardWithdrawList(params)
        commit(GET_BANKCARD_WITHDRAW_LIST, data)
    },
    async getCashierdeskAct ({ commit }, params) {
        const { data } = await getCashierdesk(params)
        commit(GET_BANKCARD_CASHIERDESK, data)
    },
    async getOpenAccountInfoAct ({ commit }, params) {
        const { data } = await getOpenAccountInfo(params)
        commit(GET_OPEN_ACCOUNT_INFO, data)
    }
}